/* assets/kargo.js */
/* Kargo Dağıtım Tablosu - Shopify uyumlu, idempotent başlatıcı */

(function () {
  // Tekrar yüklemelerde çakışmayı engelle
  if (window.__kargoInit) return;
  window.__kargoInit = true;

  // Basit seçiciler
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  // Başlatıcı (gerekli DOM hazırsa bir kez çalışır)
  function initOnce() {
    const wrap = document.querySelector('.kargo-wrap');
    if (!wrap || wrap.dataset.kargoInitialized === '1') return;

    const searchInput = $('#kargo-search', wrap);
    const todayCheckbox = $('#kargo-only-today', wrap);
    const table = $('.ty-wysiwyg-content table', wrap);

    if (!table || !searchInput || !todayCheckbox) return; // DOM tamamlanmamış olabilir

    wrap.dataset.kargoInitialized = '1';

    // Durum göstergesi (varsa tekrar ekleme)
    let toolbar = $('.kargo-toolbar', wrap);
    if (toolbar && !$('.kargo-status', toolbar)) {
      const statusEl = document.createElement('small');
      statusEl.className = 'kargo-status';
      toolbar.appendChild(statusEl);
    }
    const statusEl = $('.kargo-status', wrap);

    // Gün bilgisi
    const jsDay = new Date().getDay();
    const weekdayMap = {1:'Pts',2:'Sal',3:'Çar',4:'Per',5:'Cum',6:'Cts'};
    const todayNum = jsDay === 0 ? 0 : jsDay;

    if (todayNum === 0) {
      todayCheckbox.title = 'Pazar günleri dağıtım tanımı yok.';
    } else {
      todayCheckbox.title = 'Bugün: ' + weekdayMap[todayNum];
    }

    // Satırlar
    const rows = $$('tbody tr', table);

    // Ayraç satırı?
    const isSeparator = (tr) => {
      const tds = $$('td,th', tr);
      return tds.length && tds.every(td => !td.textContent.trim() || td.innerHTML.includes('&nbsp;'));
    };

    // Türkçe normalize
    const trMap = {'İ':'i','I':'ı','Ö':'ö','Ü':'ü','Ş':'ş','Ğ':'ğ','Ç':'ç'};
    const normalize = (s) => (s || '')
      .replace(/[İIÖÜŞĞÇ]/g, (c) => trMap[c] || c)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g,'')
      .trim();

    // Gün sütunu ayrıştırma
    const parseDays = (txt) => {
      txt = (txt || '').replace(/\s+/g,' ').trim();
      const set = new Set();
      if (!txt || /servis\s*yok/i.test(txt)) return set;

      txt.split(/\s+/).forEach((tok) => {
        if (/^\d-\d$/.test(tok)) {
          const [aStr,bStr] = tok.split('-');
          const a = Number(aStr), b = Number(bStr);
          for (let k = Math.min(a,b); k <= Math.max(a,b); k++) set.add(k);
        } else if (/^\d$/.test(tok)) {
          set.add(Number(tok));
        }
      });
      return set;
    };

    // Model
    const model = rows.map((tr) => {
      const tds = $$('td,th', tr);
      const cellsText = tds.map(td => td.textContent.replace(/\s+/g,' ').trim());
      const rowText = normalize(cellsText.join(' | '));
      const daysCell = tds[2] ? tds[2].textContent : '';
      const days = parseDays(daysCell);
      return { tr, rowText, days, isSep: isSeparator(tr) };
    });

    // Highlight
    const clearHighlights = (tr) => {
      $$('td', tr).forEach(td => {
        td.innerHTML = td.innerHTML.replace(/<mark>|<\/mark>/g,'');
      });
    };
    const highlight = (tr, q) => {
      if (!q) return;
      const pattern = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const re = new RegExp('(' + pattern + ')', 'ig');
      ['td:nth-child(1)','td:nth-child(2)'].forEach((sel) => {
        const td = tr.querySelector(sel);
        if (!td) return;
        td.innerHTML = td.innerHTML.replace(re, '<mark>$1</mark>');
      });
    };

    // No-result elemanı
    let noRes;
    const addNoResultMessage = (show) => {
      if (!noRes) {
        noRes = document.createElement('div');
        noRes.className = 'kargo-noresult';
        noRes.textContent = 'Aramanızla eşleşen sonuç bulunamadı.';
        const scroller = $('.ty-wysiwyg-content > div[style*="overflow-y"]', wrap) || $('.ty-wysiwig-content', wrap) || $('.ty-wysiwyg-content', wrap);
        (scroller?.parentNode || wrap).insertBefore(noRes, (scroller?.nextSibling || null));
      }
      noRes.style.display = show ? '' : 'none';
    };

    // Filtre
    const applyFilter = () => {
      const q = normalize(searchInput.value);
      const onlyToday = todayCheckbox.checked && todayNum !== 0;

      let shown = 0;
      model.forEach((item) => {
        const { tr, rowText, days, isSep } = item;
        clearHighlights(tr);

        if (isSep) { tr.style.display = 'none'; return; }

        const searchOk = q ? rowText.includes(q) : true;
        const todayOk = onlyToday ? days.has(todayNum) : true;

        if (searchOk && todayOk) {
          tr.style.display = '';
          shown++;
          if (q) highlight(tr, q);
        } else {
          tr.style.display = 'none';
        }
      });

      if (statusEl) statusEl.textContent = shown ? (shown + ' satır') : 'Eşleşme yok';
      addNoResultMessage(shown === 0);
    };

    // Debounce
    let t;
    const debounced = (fn, wait) => {
      wait = wait || 150;
      return function() {
        const args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(() => fn.apply(ctx, args), wait);
      };
    };

    // Eventler
    searchInput.addEventListener('input', debounced(applyFilter, 150));
    todayCheckbox.addEventListener('change', applyFilter);

    // İlk çalıştırma
    applyFilter();
  }

  // DOM hazır olduğunda başlat
  function ready(fn){ 
    if (document.readyState === 'complete' || document.readyState === 'interactive'){ 
      setTimeout(fn,0); 
    } else { 
      document.addEventListener('DOMContentLoaded', fn, { once:true }); 
    } 
  }

  ready(initOnce);

  // Shopify’da dinamik yüklemelere karşı (örn. section render) gözlemci
  const mo = new MutationObserver(() => initOnce());
  mo.observe(document.documentElement, { childList:true, subtree:true });

})();
